import { styled } from 'theme'

export const StyledMessages = styled.div`
  background-color: white;
  padding: 1rem;
  width: 40rem;
  margin: 0 auto;
`
